export const GET_ALLDETAILS_REGISTRATION = "GET_ALLDETAILS_REGISTRATION";
export const GET_ALLDETAILS_REGISTRATION_SUCCESS = "GET_ALLDETAILS_REGISTRATION_SUCCESS";
export const GET_ALLDETAILS_REGISTRATION_FAIL = "GET_ALLDETAILS_REGISTRATION_FAIL";

export const SAVE_PERSONALDETAIL_CONTENT = "SAVE_PERSONALDETAIL_CONTENT";
export const SAVE_PERSONALDETAIL_CONTENT_SUCCESS = "SAVE_PERSONALDETAIL_CONTENT_SUCCESS";
export const SAVE_PERSONALDETAIL_CONTENT_FAIL = "SAVE_PERSONALDETAIL_CONTENT_FAIL";

export const RESET = "RESET"
